"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBEmailNotification", {
  enumerable: true,
  get: function get() {
    return _SVBEmailNotification.default;
  }
});
var _SVBEmailNotification = _interopRequireDefault(require("./src/SVBEmailNotification"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }